export interface FieldDef {
  key: string;
  label: string;
}

export interface ParsedProperty {
  [key: string]: string;
}

export interface ImportError {
  row: number;
  field: string;
  message: string;
}

export const REQUIRED_FIELDS: FieldDef[] = [
  { key: "name", label: "Property Name" },
  { key: "address", label: "Address" },
  { key: "property_type", label: "Property Type" },
];

export const OPTIONAL_FIELDS: FieldDef[] = [
  { key: "city", label: "City" },
  { key: "state", label: "State" },
  { key: "zip_code", label: "ZIP Code" },
  { key: "country", label: "Country" },
  { key: "latitude", label: "Latitude" },
  { key: "longitude", label: "Longitude" },
  { key: "property_sub_type", label: "Property Sub Type" },
  { key: "property_description", label: "Property Description" },
  { key: "square_footage", label: "Square Footage" },
  { key: "year_built", label: "Year Built" },
  { key: "number_of_units", label: "Number of Units" },
  { key: "facility_image_url", label: "Facility Image URL" },
];

export const ALL_FIELDS: FieldDef[] = [...REQUIRED_FIELDS, ...OPTIONAL_FIELDS];

export function initializeColumnMapping(csvColumns: string[]): Record<string, string> {
  const mapping: Record<string, string> = {};

  ALL_FIELDS.forEach((field) => {
    const matchingColumn = csvColumns.find(
      (col) =>
        col.toLowerCase().includes(field.key.toLowerCase()) ||
        col.toLowerCase().includes(field.label.toLowerCase()) ||
        (field.key === "name" && col.toLowerCase().includes("property name")) ||
        (field.key === "property_type" && col.toLowerCase().includes("type"))
    );
    if (matchingColumn) {
      mapping[field.key] = matchingColumn;
    }
  });

  return mapping;
}
